// removed by extract-text-webpack-plugin
module.exports = {"bullet":"G3e67fc","list":"Gcea0f6","tick":"G5e51b7 Gb69063 G149cfa Gc7b2d5"};